// @flow

// Utils
const defaultArgsHasher = () => '__stable__'

// Types
export type Momoizer = Function & {
  computed: Function,
  reset: Function,
}

/**
 * Dead simple memoize implementation, which just memoize the first call
 * to the function no matter what arguments you pass to the function.
 * @param  {Function} func
 * @param  {Function} argsHash
 * @return {Function}
 */
export function memoize(
  func: Function,
  argsHasher?: (...args: any) => any = defaultArgsHasher,
  useWeakMap?: boolean
): Momoizer {
  const Collection = useWeakMap ? WeakMap : Map
  let data = new Collection()
  let computed = new Collection()

  const momoizer = (...args: any) => {
    const argsHash = argsHasher(...args)
    if (!computed.get(argsHash)) {
      computed.set(argsHash, true)
      data.set(argsHash, func(...args))
    }
    return data.get(argsHash)
  }
  momoizer.computed = (...args) => !!computed.get(argsHasher(...args))
  momoizer.reset = () => {
    data = new Collection()
    computed = new Collection()
  }
  return momoizer
}

export default memoize
